import { render } from "./FormBuilderForm.vue?vue&type=template&id=fd41e618"
import script from "./FormBuilderForm.vue?vue&type=script&lang=js"
export * from "./FormBuilderForm.vue?vue&type=script&lang=js"

import "./FormBuilderForm.vue?vue&type=style&index=0&id=fd41e618&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBreadcrumbs,QBreadcrumbsEl});
